import { getApiBaseUrl } from '@/services/config/env';

const SESSION_KEY = 'twinnee_journey_session';
const FLUSH_MS = 4000;
const MAX_BATCH = 40;

let queue = [];
let timer = null;
let clicksInstalled = false;

function sessionId() {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const created = (crypto.randomUUID && crypto.randomUUID()) || `sess-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(SESSION_KEY, created);
    return created;
  } catch {
    return `sess-${Date.now()}`;
  }
}

function currentPath() {
  return `${window.location.pathname || '/'}${window.location.search || ''}`;
}

export function trackJourney(name, properties = {}) {
  queue.push({
    name,
    path: currentPath(),
    properties: properties || {},
  });
  if (queue.length >= MAX_BATCH) {
    flushJourney();
    return;
  }
  if (!timer) {
    timer = window.setTimeout(() => {
      timer = null;
      flushJourney();
    }, FLUSH_MS);
  }
}

export function trackPageView(path) {
  trackJourney('page_view', { path: path || currentPath() });
}

async function postJourney(path, body) {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const token = localStorage.getItem('storycraft_token');
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch {
    /* storage unavailable */
  }
  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    keepalive: true,
  });
  if (!response.ok) {
    throw new Error(`journey ${response.status}`);
  }
}

export async function flushJourney() {
  if (!queue.length) return;
  const batch = queue.splice(0, MAX_BATCH);
  try {
    await postJourney('/journey/events', {
      session_id: sessionId(),
      events: batch,
    });
  } catch {
    queue = [...batch, ...queue].slice(0, MAX_BATCH);
  }
}

export async function identifyJourneySession() {
  try {
    if (!localStorage.getItem('storycraft_token')) return;
  } catch {
    return;
  }
  try {
    await postJourney('/journey/identify', { session_id: sessionId() });
  } catch {
    /* identity can be attached on the next page view */
  }
}

function clickLabel(element) {
  const aria = element.getAttribute('aria-label') || '';
  const text = (element.innerText || aria || '').replace(/\s+/g, ' ').trim();
  return text.slice(0, 80);
}

export function installJourneyClicks() {
  if (clicksInstalled || typeof document === 'undefined') return;
  clicksInstalled = true;
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;
    const element = target.closest('button, a, [role="button"]');
    if (!element) return;
    if (element.closest('[data-journey-ignore]')) return;
    const label = clickLabel(element);
    const testid = element.getAttribute('data-testid') || '';
    if (!label && !testid) return;
    trackJourney('click', {
      label: label || undefined,
      testid: testid || undefined,
    });
  }, true);
  window.addEventListener('pagehide', () => {
    flushJourney();
  });
}
